<div
  [@slideAnimation]="{ value: animationState, params: animationParams() }"
  class="notification-toast"
  data-test="notification-toast"
  [ngClass]="positionClasses()"
  role="alert"
  aria-live="polite"
  aria-atomic="true"
>
  <div
    class="toast-content"
    data-test="toast-content"
    [class.clickable]="config.clickable"
    (click)="handleClick($event)"
    [attr.role]="config.clickable ? 'button' : null"
    [attr.tabindex]="config.clickable ? '0' : null"
    (keydown.enter)="handleClick($event)"
    (keydown.space)="handleClick($event)"
  >
    <div class="toast-icon-wrapper" *ngIf="iconName">
      <iris-icon
        [name]="iconName"
        [colorToken]="iconColorToken"
        [size]="IconSizes.MD"
        [usage]="IconUsageTypes.DECORATIVE"
      ></iris-icon>
    </div>

    <div class="toast-message">
      <span *ngIf="message">{{ message }}</span>
    </div>

    <iris-icon-button
      *ngIf="showCloseButton"
      [type]="IrisIconButtonTypes.TERTIARY"
      icon="close"
      class="close-toast-button"
      (click)="close()"
      ariaLabel="Close notification"
    >
    </iris-icon-button>
  </div>
</div>
